export class ThrottleGuard {
  private lastExecuted = new Map<string, number>();

  constructor(private defaultWindowMs: number = 1000) {}

  /** Returns true if operation can proceed, false if throttled */
  tryExecute(key: string, windowMs: number = this.defaultWindowMs): boolean {
    const now = Date.now();
    const last = this.lastExecuted.get(key) ?? 0;

    if (now - last >= windowMs) {
      this.lastExecuted.set(key, now);

      return true;
    }

    return false;
  }
}
